const PRODUCTS_TOP_BAR_CLASSES_PREFIX = "products-top-bar";

export const PRODUCTS_TOP_BAR_CLASSES = {
  hideOnMobile: `${PRODUCTS_TOP_BAR_CLASSES_PREFIX}-hideOnMobile`,
  openFiltersBtn: `${PRODUCTS_TOP_BAR_CLASSES_PREFIX}-openFiltersBtn`,
};
